import FleetView from "./FleetViewPage";

export default FleetView;